import getUrl from 'api/apiMap'
import useGetApi from '../useGetApi'
import useMutateApi from '../useMutateApi'
import axios from 'axios'
// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

const useGetRequestTypes = () => {
  return useGetApi(getUrl(`${apiEndpoints.requestTypesList}`), queryKeys.requestTypes.all)
}

const usePostRequestType = () => {
  return useMutateApi({
    method: 'post',
    apiEndpoint: getUrl(apiEndpoints.requests),
    invalidateQueries: [queryKeys.requests.all],
    successMsg: 'Successfully created request',
  })
}

// TODO: use react-query filter-set hooks instead
const UseGetRequestIds = () => {
  let data = axios.post(getUrl(apiEndpoints.filterSet), {
    app_name: 'datasharing',
    model: 'DSRequest',
    field: 'request_id',
    model_parent: 'Request'
  })
  return data
}

// TODO: use react-query filter-set hooks instead
const UseGetRequestState = () => {
  let data = axios.post(getUrl(apiEndpoints.filterSet), {
    app_name: 'workflow',
    model: 'WorkflowStateTemplate',
    field: 'title',
    model_parent: 'RequestType'
  })
  return data
}

// const useGetRequestIds

export {
  useGetRequestTypes,
  usePostRequestType,
  UseGetRequestIds,
  UseGetRequestState
}